import { Injectable, signal } from '@angular/core';

export enum MicStatus {
  Recording = 'recording',
  Listening = 'listening',
  Inactive = 'inactive',
}

// Optional: Keep MicModes if it's used elsewhere, or integrate its logic if related
enum MicModes {
  WebRecognition = 'WebRecognition',
  CapacitorRecognition = 'CapacitorRecognition',
  RecordingWhilePressButton = 'RecordingPressButton',
  RecordingUntilSilence = 'RecordingUntilSilence',
}

@Injectable({
  providedIn: 'root',
})
export class MicStateService {
  // Signals for mic state
  public isListening = signal(false);
  public severity = signal<any>('secondary'); // Consider a more specific type if possible e.g. 'primary' | 'info' | 'secondary'
  public icon = signal('pi pi-microphone');
  public currentStatus = signal<MicStatus>(MicStatus.Inactive);

  // Optional: If MicModes is still relevant for other parts of the application
  public recodingStatus: MicModes = MicModes.RecordingUntilSilence;
  public mode: MicModes = MicModes.WebRecognition;

  constructor() {}

  // Moved and adapted from DCMicComponent
  public changeMicStatus(status: MicStatus) {
    this.currentStatus.set(status);
    if (status === MicStatus.Recording) {
      this.severity.set('primary');
      this.isListening.set(true);
      this.icon.set('pi pi-circle-on');
      console.log('Changing state to recording in service');
    } else if (status === MicStatus.Listening) {
      this.severity.set('danger');
      this.isListening.set(true);
      this.icon.set('pi pi-circle-off');
      console.log('Changing state to listening in service');
    } else if (status === MicStatus.Inactive) {
      this.isListening.set(false);
      this.icon.set('pi pi-microphone');
      this.severity.set('secondary');
      console.log('Changing state to inactive in service');
    }
  }
}
